<template>
  <b-modal id="create-care" hide-footer>
    <template v-slot:modal-title>Cuidado</template>
    <div class="d-block">
      <div class="container">
        <div class="row">
          <div class="col-md-12">
            <LabelRequiredField label="Nome" />

            <input type="text" v-model="name" class="form-control" />
          </div>

          <ErrorsMessages :errors="errors" />

          <div class="col-md-12 text-right">
            <v-btn
              :disabled="loading"
              type="submit"
              class="v-success"
              @click="create"
            >
              <span class="fa fa-check"></span>
              {{ loading ? "Carregando" : "Salvar" }}
            </v-btn>
          </div>
        </div>
      </div>
    </div>
  </b-modal>
</template>

<script>
import ErrorsMessages from "../components/ErrorsMessages";

import LabelRequiredField from "../components/LabelRequiredField";

import api from "../../services/api";

import toast from "../../components/ToastNotification";

export default {
  name: "CreateModal",

  components: {
    LabelRequiredField,
    ErrorsMessages,
  },

  data() {
    return {
      loading: false,

      errors: [],

      name: "",
    };
  },

  methods: {
    async create() {
      try {
        this.loading = true;

        const { name } = this;

        let params = { name };

        const response = await api.post(
          "/admin/prescription-care-item/create",
          params
        );

        const { error, errors, message } = response.data;

        if (!error) {
          this.name = "";

          toast(message, "success");

          this.$emit("create");

          this.$bvModal.hide("create-care");
        } else {
          this.errors = errors;
        }

        this.loading = false;
      } catch (error) {
        this.loading = false;

        console.log(error);
      }
    },
  },
};
</script>